module.exports = __webpack_public_path__ + "img/img_product_07_01@2x.58927728.png";